(function () {
  const COLOR = "#1f2021";
  const COLOR_RGB = "rgb(31, 32, 33)"; // how the browser serialises #1f2021
  const SELECTOR = ".gravity-button";
  const watched = new WeakSet();

  /** Collect the main document + every open shadow root on the page
      (recursing into nested shadow roots). */
  function collectRoots(root, out) {
    root = root || document;
    out = out || [document];
    const hosts = root.querySelectorAll("*");
    for (let i = 0; i < hosts.length; i++) {
      const sr = hosts[i].shadowRoot;
      if (sr && out.indexOf(sr) === -1) {
        out.push(sr);
        collectRoots(sr, out);
      }
    }
    return out;
  }

  function paint() {
    const roots = collectRoots();
    for (const root of roots) {
      // Keep watching shadow roots for their own internal re-renders.
      if (root !== document && !watched.has(root)) {
        watched.add(root);
        new MutationObserver(schedule).observe(root, {
          childList: true,
          subtree: true,
        });
      }

      let buttons;
      try {
        buttons = root.querySelectorAll(SELECTOR);
      } catch (e) {
        continue;
      }
      for (const btn of buttons) {
        if (getComputedStyle(btn).backgroundColor !== COLOR_RGB) {
          btn.style.setProperty("background-color", COLOR, "important");
        }
      }
    }
  }

  let timer = 0;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(paint, 100);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  schedule();
  window.addEventListener("load", schedule);
  document.addEventListener("shopify:section:load", schedule); // theme editor
})();
